import React from 'react'
import {useTranslation} from 'react-i18next'
import {Outlet} from 'react-router'

import {PlannerPageLayout} from '../components/shared'
import {FEATURE_NAMESPACE} from '../consts'

export const PageProductionPlanning: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <PlannerPageLayout
      pageTitle={t('navItems.productionPlanning')}
      data-test-id="page_productionPlanning"
    >
      <Outlet />
    </PlannerPageLayout>
  )
}
